import { render, staticRenderFns } from "./ParametersCoreCategory.vue?vue&type=template&id=a1fea7ba&scoped=true&"
import script from "./ParametersCoreCategory.vue?vue&type=script&lang=js&"
export * from "./ParametersCoreCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fea7ba",
  null
  
)

export default component.exports